import { render, staticRenderFns } from "./NewAmenitiesCards.vue?vue&type=template&id=0dbfdc4c&scoped=true&"
import script from "./NewAmenitiesCards.vue?vue&type=script&lang=js&"
export * from "./NewAmenitiesCards.vue?vue&type=script&lang=js&"
import style0 from "./NewAmenitiesCards.vue?vue&type=style&index=0&id=0dbfdc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbfdc4c",
  null
  
)

export default component.exports